import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import {
  EditPayoutAccountDialogComponent,
  EditPayoutAccountDialogData,
  EditPayoutAccountDialogResult,
} from './edit-payout-account-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class EditPayoutAccountDialogService {
  private readonly dialog = inject(MatDialog);

  async openDialog({
    input: data,
  }: {
    input: EditPayoutAccountDialogData;
  }): Promise<EditPayoutAccountDialogResult | undefined> {
    const dialogRef = this.dialog.open<
      EditPayoutAccountDialogComponent,
      EditPayoutAccountDialogData,
      EditPayoutAccountDialogResult
    >(EditPayoutAccountDialogComponent, {
      data,
      width: '600px',
      maxWidth: '90vw',
      disableClose: false,
      panelClass: 'rounded-dialog',
    });

    return firstValueFrom(dialogRef.afterClosed());
  }
}
